import get from 'lodash/get';
import omit from 'lodash/omit';
import { Form } from 'react-bootstrap';
import { Control, FieldErrors, FieldValues, UseFormRegister, useController } from 'react-hook-form';
import { ApiError } from '../../../api';
import { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { ScaleSelect } from '../ScaleSelect';

interface FormScaleSelectFieldProps {
  name: string;
  label: string;
  options: { [key: string]: string };
  serverErrors?: ApiError;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showServerFieldErrors?: ShowFieldErrors;
  setShowServerFieldErrors?: (showServerFieldErrors: ShowFieldErrors) => void;
  errors: FieldErrors<FieldValues>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<FieldValues, any>;
  extraFieldErrorsToHideOnChange?: string[];
  required?: boolean;
  srOnlyLabel?: boolean;
}

export const FormScaleSelectField = ({
  name,
  label,
  options,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  control,
  extraFieldErrorsToHideOnChange = [],
  required = false,
  srOnlyLabel = false,
  ...rest
}: FormScaleSelectFieldProps & Parameters<typeof Form.Control>[0]) => {
  const { field } = useController({
    name,
    control,
  });
  return (
    <Form.Group className="mb-3">
      <Form.Label className={`text-primary fw-bold ${srOnlyLabel ? 'visually-hidden' : ''}`}>
        {label}
        {required ? <span className="text-danger"> *</span> : ''}
      </Form.Label>
      <ScaleSelect
        options={options}
        isInvalid={!!errors[name] || !!get(showServerFieldErrors, name)}
        onChange={(value) => {
          setShowServerFieldErrors?.({
            ...omit(showServerFieldErrors, [name, ...extraFieldErrorsToHideOnChange]),
          });
          field.onChange(value);
          field.onBlur();
        }}
        {...rest}
      />
      <FormFeedback
        clientError={errors[name]}
        serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
      />
    </Form.Group>
  );
};
